<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="380">
    <v-card>
        <v-toolbar dense class="mb-4" color="primary" dark>
           BORROW EMPTIES
           <v-spacer/>
           <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text>
           <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
              <v-autocomplete
                  v-model="borrowed.type"
                  label="Borrow or Return"
                    :rules="textRules"
                    required
                  dense
                  outlined
                  :items="['Borrowed', 'Returned']"
                  persistent-hint
                  :hint="ITEM.description"
                />
              <v-autocomplete
                  v-model="supplier"
                  label="SUPPLIER"
                  :items="$store.state.suppliers"
                  item-text="company"
                  item-value="id"
                  dense
                  outlined
                  filled
                />
              <v-autocomplete
                  v-model="borrowed.product_code"
                  label="Product code"
                    :rules="textRules"
                    required
                  dense
                  item-text="code"
                  item-value="code"
                  outlined
                  :items="EMPTIES"
                  persistent-hint
                  :hint="ITEM.description"
                />

                 <v-text-field 
                 :disabled="true"
                 :value="ITEM.price_per_unit"
                  label="Unit Price"
                  dense
                  outlined
                />
                 <v-text-field 
                 v-model="borrowed.quantity"
                  label="Quantity"
                  type="number"
                   :rules="textRules"
                    required
                  requir
                  dense
                  outlined
                />
           </v-form>
        </v-card-text>
         
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  small color="success" rounded depressed  @click="validate()"><v-icon small left>mdi-check</v-icon>BORROW</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapMutations
} from 'vuex'
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    method: {
      type: String,
      default:''
    },
    sales: {
      type: Object,
      default:()=>{}
    }
  },
  data: () => ({
    valid: true,
    supplier:0,
      borrowed:{},
      borrow:{},
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
       EMPTIES(){
        var lists = this.$store.state.products
        var arr =  lists.reduce((res, item)=>{
            if(item.type=="empties" && item.supplier == this.supplier) {
                res.push(item)
            }
            return res
        },[])
        return arr
      },
      ITEM(){
        var arr =  this.EMPTIES.reduce((res, item)=>{
            if(item.code==this.borrowed.product_code) {
                res = item
            }
            return res
        },{})
        return arr
      }
  },
  watch: {
    show(v) {
      if(v) {
        this.product = {}
        this.borrow={}
      }
    }
  },
  methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText']),
    emitToParent (action) {
        this.$emit('DialogEvent',action)
    },
  validate () {
        if (this.$refs.form.validate()) {
          this.addItem()
        }
      },
    addItem(){
      var param = {}
      param.invoice = this.sales.invoice
      param.product_code = this.borrowed.product_code
      param.type = this.borrowed.type
       param.unit_price= this.$IsNum(this.ITEM.price_per_unit)
      param.quantity = this.$IsNum(this.borrowed.quantity)
      param.amount  = this.$IsNum(this.borrowed.quantity) * this.$IsNum(this.ITEM.price_per_unit)
      param.customer_id = this.sales.customer
       this.$http.post("borrow/add", param).then(response => {
         this.GET_RESPONSE(response)
           this.$emit('DialogEvent', "close")
          }).catch(e => {
            console.log(e.data)
        }) 
    }
  }
}
</script>
